<template>
  <div class="content">
    <div class="pdf-wrap">
      <!-- <div id="downloadWrapper" style="background:#ccc" @click="download">下载</div> -->
      <pdf v-for="i in numPages" :key="i" :src="src" :page="i" style="display: inline-block; width: 100%"></pdf>
    </div>
    <div class="action-wrap fixed-footer">
      <van-button type="primary" size="large" @click="downloadReportPdf" v-if="base64Data">下载到本地</van-button>
    </div>
    <van-overlay class="overlay-wrap" :show="showTips" lock-scroll="true" @click="showTips = false">
      <div class="tips-arrow">
        <img src="@/assets/images/arrow-upper-right.png" />
      </div>
      <div class="tips-txt">
        <p>请点击右上角</p>
        <p>选择在浏览器打开~</p>
      </div>
    </van-overlay>

  </div>
</template>

<style lang="less" scoped>
  .content {

    .pdf-wrap {
      padding-bottom: 72px;
    }

    .action-wrap {
      padding: 8px;
    }

    .overlay-wrap {
      z-index: 9999;

      // z-index: 1;
      .tips-arrow {
        position: absolute;
        top: 8px;
        right: 24px;
      }

      .tips-txt {
        position: absolute;
        top: 20vh;
        left: 15%;
        right: 15%;
        border: 1px solid #fff;
        border-radius: 8px;
        color: #fff;
        font-size: 20px;
        text-align: center;
        padding: 24px;
      }
    }
  }
</style>

<script>
  import Vue from "vue";
  import VueJsonp from "vue-jsonp";
  Vue.use(VueJsonp);
  import {
    Overlay
  } from 'vant';

  Vue.use(Overlay);
  import pdf from "vue-pdf";
  import {
    getPdfReport
  } from '@/api/report'
  import {
    download,
    downloadFile
  } from "@/libs/download.js";
  export default {
    components: {
      pdf
    },
    data() {
      return {
        src: undefined,
        numPages: undefined,
        base64Data: undefined,
        showTips: false,
      };
    },
    mounted() {
      let reportKey = this.$route.query.reportKey;
      let _this = this;
      getPdfReport(reportKey).then(res => {
        if (res.code !== 200) {
          _this.$toast(res.msg);
          return
        } else {
          _this.base64Data = res.data;
        }

        //接口返回的是base64，需要进行转换
        var pdfData = _this.base64ToUint8Array(res.data);

        //封装pdf.js的进行pdf文件加载
        var loadingPdfTask = pdf.createLoadingTask(pdfData);

        _this.src = loadingPdfTask;
        // _this.numPages = pdf.numPages;
        _this.src.promise.then(pdf => {
          _this.numPages = pdf.numPages;
        });
      }).catch(err => {
        this.$toast.fail("查询体检报告出错");
        console.log(err);
      })
      // let url =
      //   "http://180.168.200.201:8081/api/tjgl/getpdfreport?tjbh=9600815056";
      // let _this = this;
      // this.$jsonp(url)
      //   .then(json => {
      //     console.log(json.reason);
      //     if (json.resultcode !== "0") {
      //       return;
      //     }
      //     _this.base64Data = json.result;
      //     //接口返回的是base64，需要进行转换
      //     var pdfData = _this.base64ToUint8Array(json.result);

      //     //封装pdf.js的进行pdf文件加载
      //     var loadingPdfTask = pdf.createLoadingTask(pdfData);

      //     _this.src = loadingPdfTask;
      //     // _this.numPages = pdf.numPages;
      //     _this.src.promise.then(pdf => {
      //       _this.numPages = pdf.numPages;
      //     });
      //   })
      //   .catch(err => {
      //     console.log(err);
      //     // Failed.
      //   });
    },
    methods: {

      is_weixin() {
        var ua = window.navigator.userAgent.toLowerCase();
        if (ua.match(/MicroMessenger/i) == 'micromessenger') {
          console.log('微信浏览器');
          return true;
        } else {
          console.log("不是微信浏览器");
          return false;
        }
      },
      download1() {
        if (this.is_weixin()) {
          this.showTips = true;
          return;
        }

        let Base64String = this.base64Data; //后端返回的base64字符串
        const blob = new Blob(this.base64ToBlob(this.base64Data), {
          type: "application/pdf;chartset=UTF-8",
        });

        let fileName = "体检报告.pdf"; //下载的文件名称
        let prefix = "data:application/ms-pdf;base64,";
        let a = document.createElement("a"); //创建a标签
        let content = prefix + Base64String;
        a.setAttribute("href", content);
        a.setAttribute("download", fileName);
        a.setAttribute("target", "_blank"); //打开一个新的窗口
        a.setAttribute("id", "downLoad");
        if (document.getElementById("downLoad")) {
          document.body.removeChild(document.getElementById("downLoad"));
        }
        document.body.appendChild(a);
        a.click();
      },

      downloadPdf() {
        if (this.is_weixin()) {
          this.showTips = true;
          return;
        }
        // const blob = new Blob(this.base64ToBlob(this.base64Data), {
        //   type: "application/pdf;chartset=UTF-8",
        // });
        const blob = this.base64ToBlob(this.base64Data);
        const a = document.createElement("a");
        const URL = window.URL || window.webkitURL;
        const herf = URL.createObjectURL(blob);
        a.href = herf;
        // 这里后台不给文件名字需要自己写
        a.download = '体检报告.pdf';
        document.body.appendChild(a);
        a.click();
        document.body.removeChild(a);
        window.URL.revokeObjectURL(herf)
      },
      downloadReportPdf() {
        if (this.is_weixin()) {
          this.showTips = true;
          return;
        }
        const blob = this.base64ToBlob(this.base64Data);
        download(blob, "体检报告.pdf", "application/pdf");
        //let reportKey = this.$route.query.reportKey;
        //window.location.href = window.APIURL.rootUrl + '/api/report/DownloadReport?reportKey=' + reportKey;
      },
      base64ToUint8Array(base64String) {
        const padding = "=".repeat((4 - (base64String.length % 4)) % 4);
        const base64 = (base64String + padding)
          .replace(/-/g, "+")
          .replace(/_/g, "/");

        const rawData = window.atob(base64);
        const outputArray = new Uint8Array(rawData.length);

        for (let i = 0; i < rawData.length; ++i) {
          outputArray[i] = rawData.charCodeAt(i);
        }
        return outputArray;
      },

      base64ToBlob(b64Data) {
        var bstr = atob(b64Data);
        var n = bstr.length;
        var u8arr = new Uint8Array(n);
        while (n--) {
          u8arr[n] = bstr.charCodeAt(n);
        }
        return new Blob([u8arr], {
          type: "application/pdf;chartset=UTF-8"
        });
      }

    }
  };
</script>